import './Recorder.css';
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import AudioPlayer, { RHAP_UI } from 'react-h5-audio-player';

import 'react-h5-audio-player/lib/styles.css';

import vmsg from "vmsg";

const WarningIcon = require('../../images/WarningIcon.svg');

const recorder = new vmsg.Recorder({
    wasmURL: "https://unpkg.com/vmsg@0.3.0/vmsg.wasm"
});

export const Recorder = ({onUserConfirmedRecording, commentEditState}) => {

    const MAX_RECORDING_LENGTH = 600000;

    const [isRecording, setIsRecording] = useState(false);
    const [audioUrl, setAudioUrl] = useState(null);
    const [audioBlob, setAudioBlob] = useState(null);
    const [recordStart, setRecordStart] = useState(42);
    const [recordingTime, setRecordingTime] = useState(0);

    useEffect(() => {
        return () => {
            if (isRecording) {
                handleStop();
                recorder.close();
            }
        };
    }, [])


    useEffect(() => {
        let timeout = null;
        if (isRecording) {
            timeout = setTimeout(() => {
                if (recordingTime > (MAX_RECORDING_LENGTH + 1000)) {
                    handleStop();
                    alert(`Recording stopped after reaching maximum time of ${msToTime(MAX_RECORDING_LENGTH)}`)
                } else {
                    setRecordingTime(Date.now() - recordStart);
                }
            }, 100);
        }
        return () => clearTimeout(timeout);
    }, [isRecording, recordingTime, recordStart]);


    function msToTime(duration) {
        let seconds = Math.floor((duration / 1000) % 60),
            minutes = Math.floor((duration / (1000 * 60)) % 60),
            hours = Math.floor((duration / (1000 * 60 * 60)) % 24);

        hours = (hours < 10) ? "0" + hours : hours;
        minutes = (minutes < 10) ? "0" + minutes : minutes;
        seconds = (seconds < 10) ? "0" + seconds : seconds;

        return minutes + ":" + seconds;
    }

    const handleStart = async() => {
        commentEditState.setHasAudio(true);
        try {
            await recorder.initAudio();
            await recorder.initWorker();
            recorder.startRecording();
            setIsRecording(true);
            setRecordStart(Date.now());
            setRecordingTime(0);
        } catch (e) {
            console.error(e);
            setIsRecording(false);
        }
    };

    const handleStop = async() => {
        try {
            await recorder.stopTracks();
            const blob = await recorder.stopRecording();
            setIsRecording(false);
            const blobUrl = URL.createObjectURL(blob);
            setAudioUrl(blobUrl);
            setAudioBlob(blob);
        } catch (e) {
            console.error(e);
            setIsRecording(false);
        }
    };

    const handleSave = () => {
        commentEditState.setHasAudio(false);
        if (onUserConfirmedRecording) {
            onUserConfirmedRecording(audioBlob, audioUrl, recordingTime);
        }
    };

    const handleClear = () => {
        commentEditState.setHasAudio(false);
        setAudioUrl(null);
    };

    const progressPercent = () => {
        let complete = recordingTime / MAX_RECORDING_LENGTH;
        if (complete >= 1) {
            complete = 1;
        }
        return `${complete * 100}%`;
    };

    return (
        <div>
            {(isRecording && recordingTime > (MAX_RECORDING_LENGTH * .90)) && (
                <div className={`recorder__warning ${recordingTime > (MAX_RECORDING_LENGTH * .95) ? 'urgent' : ''}`}>
                    <p>
                        <img className="recorder__warning__icon" src={WarningIcon} alt="Warning"/>
                        Approaching {MAX_RECORDING_LENGTH/1000/60}-minute recording limit.
                    </p>
                </div>
            )}
            <div className="recorder">
                {audioUrl ? (
                    <React.Fragment>
                        <AudioPlayer
                            src={audioUrl}
                            customAdditionalControls={[]}
                            layout="horizontal-reverse"
                            customVolumeControls={[]}
                            showJumpControls={false}
                            customProgressBarSection={
                                [
                                    RHAP_UI.PROGRESS_BAR,
                                    RHAP_UI.CURRENT_TIME,
                                ]
                            }
                        />
                        <div className="recorder__actionButtons">
                            <button onClick={handleClear} className="recorder__actionBtn recorder__actionBtn--danger">
                                Clear
                            </button>
                            <button onClick={handleSave} className="recorder__actionBtn recorder__actionBtn--confirm">
                                Add
                            </button>
                        </div>
                    </React.Fragment>
                ) : (
                    <React.Fragment>
                        {isRecording ? (
                            <React.Fragment>
                                <button onClick={handleStop} className="recorder__btn recorder__btn--stop">
                                    Stop Recording
                                </button>
                                <div className="recorder__progress">
                                    <div className="recorder__progress__track"></div>
                                    <div className="recorder__progress__bar" style={{width: progressPercent()}}></div>
                                </div>
                                <div className="recorder__time">
                                    {msToTime(recordingTime)}
                                </div>
                            </React.Fragment>
                        ) : (
                            <React.Fragment>
                                <button onClick={handleStart} className="recorder__btn recorder__btn--record">
                                    Start Recording (Up to {MAX_RECORDING_LENGTH/1000/60} min)
                                </button>
                                <span className="recorder__label">Start Recording (Up to {MAX_RECORDING_LENGTH/1000/60} min)</span>
                            </React.Fragment>
                        )}
                    </React.Fragment>
                )}

            </div>

            <div className="recorder__instructions">
                <p>
                    <strong>Do a “Test 1-2-3” to confirm your set-up, then listen to part of each recorded comment to
                        verify quality before adding.</strong>
                </p>
                <p>
                    Recording quality can vary among browser, device, and mic options.
                </p>
                <p>
                    <a className="recorder__link"
                       href="https://tightknit.freshdesk.com/support/solutions/articles/43000631073-tips-for-recording-audio-comments"
                       target="_blank"
                       rel="noopener" >
                    Recording Tutorial
                    </a>
                </p>
            </div>

        </div>
    )
};

Recorder.propTypes = {
    onUserConfirmedRecording: PropTypes.func,
};



// WEBPACK FOOTER //
// ./src/_components/AudioRecorder/Recorder.js